import React from 'react';

import { ServiceTitanAppointment, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { FlexBox } from '_lib/components/FlexBox/FlexBox';
import { Typography } from '_lib/components/Typography/Typography';
import { DateFormatEnum, DateUtils } from '_lib/utils/date.utils';
import { getAppointmentNumberAndStatus } from '_lib/utils/helpers';

type AppointmentDisplayProps = {
  serviceTitanAppointment: ServiceTitanAppointment;
  jobNo: string;
  timezone: TimezoneAbbreviationEnum;
};

export const AppointmentDisplay = (props: AppointmentDisplayProps) => {
  const { serviceTitanAppointment, jobNo, timezone } = props;

  return (
    <FlexBox sx={{ flexDirection: 'column' }}>
      <Typography text={getAppointmentNumberAndStatus(serviceTitanAppointment, jobNo)} />
      <Typography
        text={DateUtils.format(serviceTitanAppointment.start, DateFormatEnum.DateTimeWeekday, {
          timezone,
          showTimezone: true
        })}
      />
    </FlexBox>
  );
};
